import React, { useEffect, useMemo, useRef, useState } from "react";
import "./index.css";

const MIN = 0;
const MAX = 1;
const STEP = 0.05;

// ---------------- cookies (persist slider state per model / per mode) ----------------
// Pass `storageKey` prop (ideally unique per model, e.g. `thresholds:${modelId}`)
// We store Threshold and Metrics state separately, so they don't affect each other.
// const DEFAULT_STORAGE_KEY = "threshold-slider";

// function setCookie(name, value, days = 365) {
//   try {
//     const maxAge = days * 24 * 60 * 60; // seconds
//     document.cookie = `${encodeURIComponent(name)}=${encodeURIComponent(
//       value
//     )}; Max-Age=${maxAge}; Path=/; SameSite=Lax`;
//   } catch (e) {
//     // ignore (SSR / blocked cookies)
//   }
// }

// function getCookie(name) {
//   try {
//     const encoded = encodeURIComponent(name) + "=";
//     const parts = String(document.cookie || "")
//       .split(";")
//       .map((p) => p.trim());
//     for (const part of parts) {
//       if (part.startsWith(encoded)) return decodeURIComponent(part.slice(encoded.length));
//     }
//   } catch (e) {
//     // ignore
//   }
//   return null;
// }

// function safeParseJSON(raw) {
//   try {
//     return JSON.parse(raw);
//   } catch {
//     return null;
//   }
// }

// СКІЛЬКИ ТОЧОК НА ШКАЛІ В METRICS (включно з min і max)
// 6 = min + 4 внутрішні + max (як у тебе зараз)
const METRICS_TICKS_COUNT = 7;

function clamp(value, min, max) {
  return Math.min(max, Math.max(min, value));
}

function roundToStep(value, step) {
  return Math.round(value / step) * step;
}

function toNumber(v, fallback = 0) {
  const n = Number(String(v ?? "").replace(",", "."));
  return Number.isFinite(n) ? n : fallback;
}

// ТІЛЬКИ ВІЗУАЛ: format до N знаків, але прибираємо зайві нулі справа
// 1.0000 -> "1", 0.8000 -> "0.8", 0.9500 -> "0.95"
function fmt(v, decimals = 4) {
  const n = Number(v);
  if (!Number.isFinite(n)) return "";
  const s = n.toFixed(decimals);
  return s.replace(/(\.\d*?[1-9])0+$/g, "$1").replace(/\.0+$/g, "").replace(/\.$/g, "");
}

const METRIC_OPTIONS = [
  { value: "accuracy", label: "accuracy" },
  { value: "f1Score0", label: "f1Score0" },
  { value: "f1Score1", label: "f1Score1" },
  { value: "precision0", label: "precision0" },
  { value: "precision1", label: "precision1" },
  { value: "recall0", label: "recall0" },
  { value: "recall1", label: "recall1" },
];

export default function ThresholdSlider({
  lower,
  upper,
  data = [],
  onCommit,
  onChange,
}) {
  const commitCb = onCommit || onChange || (() => {});

  // ---------------- persistence: separate for each tab ----------------
  // Зберігаємо локально (localStorage), щоб:
  // - Threshold (double) пам’ятав свій lower/upper
  // - Metrics пам’ятав metric + позицію
  // і вони НЕ перетирали одне одного.
  // const baseKey = storageKey || DEFAULT_STORAGE_KEY;
  // const keyDouble = `${baseKey}:double`;
  // const keyMetrics = `${baseKey}:metrics`;

  // const safeRead = (k) => {
  //   if (!k) return null;
  //   try {
  //     const raw = getCookie(k);
  //     return raw ? JSON.parse(raw) : null;
  //   } catch {
  //     return null;
  //   }
  // };

  // const safeWrite = (k, payload) => {
  //   if (!k) return;
  //   try {
  //     setCookie(k, JSON.stringify(payload), 365);
  //   } catch {
  //     // ignore
  //   }
  // };

  const [mode, setMode] = useState("double");

  // RAW значення двох ручок (можуть перетинатися)
  const [rawLeft, setRawLeft] = useState(0.5);
  const [rawRight, setRawRight] = useState(0.5);

  // sorted lower/upper для показу (і для заливки range)
  const sorted = useMemo(() => {
    const lo = Math.min(rawLeft, rawRight);
    const hi = Math.max(rawLeft, rawRight);
    return { lo, hi };
  }, [rawLeft, rawRight]);

  // Metrics
  const [metricKey, setMetricKey] = useState(METRIC_OPTIONS[0].value);
  const [draftIndex, setDraftIndex] = useState(0);
  // текстове поле в Metrics режимі (щоб можна було і тягнути, і вводити руками)
  const [metricValueText, setMetricValueText] = useState("");
  const metricEditingRef = useRef(false);

  // const loadedRef = useRef({ double: false, metrics: false, hadSavedDouble: false, hadSavedMetrics: false });
  // const skipInitialPropSyncRef = useRef(true);

  // хто тягнеться
  const draggingRef = useRef(null);
  // ---- restore saved state (separate for Threshold vs Metrics) ----
  // useEffect(() => {
  //   // reset flags when model/storage changes
  //   loadedRef.current = { double: false, metrics: false, hadSavedDouble: false, hadSavedMetrics: false };

  //   const savedDouble = safeRead(keyDouble);
  //   if (savedDouble && Number.isFinite(Number(savedDouble.rawLeft)) && Number.isFinite(Number(savedDouble.rawRight))) {
  //     loadedRef.current.hadSavedDouble = true;
  //     const l = clamp(roundToStep(Number(savedDouble.rawLeft), STEP), MIN, MAX);
  //     const r = clamp(roundToStep(Number(savedDouble.rawRight), STEP), MIN, MAX);
  //     setRawLeft(l);
  //     setRawRight(r);
  //   }

  //   const savedMetrics = safeRead(keyMetrics);
  //   if (savedMetrics && typeof savedMetrics.metricKey === "string") {
  //     loadedRef.current.hadSavedMetrics = true;
  //     // set metricKey first, index will be clamped once sortedByMetric is ready
  //     setMetricKey(savedMetrics.metricKey);
  //     if (Number.isFinite(Number(savedMetrics.draftIndex))) {
  //       setDraftIndex(Number(savedMetrics.draftIndex));
  //     } else {
  //       setDraftIndex(0);
  //     }
  //   }

  //   // allow prop sync after first pass if you later add it
  //   skipInitialPropSyncRef.current = false;
  // }, [keyDouble, keyMetrics]);

  // ---- simple persistence (DO NOT mix modes) ----
  // ---------------- METRICS MODE: сортування + дискретні кроки ----------------
  const sortedByMetric = useMemo(() => {
    return (data || [])
      .filter((o) => Number.isFinite(Number(o?.[metricKey])))
      .slice()
      .sort((a, b) => Number(a[metricKey]) - Number(b[metricKey]));
  }, [data, metricKey]);

  function sameStep(a, b, step = STEP) {
    return Math.abs(roundToStep(Number(a), step) - roundToStep(Number(b), step)) < 1e-9;
  }

  const metricMaxIndex = Math.max(0, sortedByMetric.length - 1);

  useEffect(() => {
    setDraftIndex((idx) => clamp(idx, 0, metricMaxIndex));
  }, [metricMaxIndex]);

  const metricIndexFromThreshold = useMemo(() => {
    if (!sortedByMetric.length) return 0;

    const idx = sortedByMetric.findIndex(
      (o) =>
        sameStep(o?.lowerThreshold, lower) &&
        sameStep(o?.upperThreshold, upper)
    );

    return idx >= 0 ? idx : 0;
  }, [sortedByMetric, lower, upper]);

  const selectedMetricObj = sortedByMetric[draftIndex] || null;

  const selectedMetricValue = selectedMetricObj
    ? Number(selectedMetricObj[metricKey])
    : 0;

  const metricMinValue = sortedByMetric.length
    ? Number(sortedByMetric[0][metricKey])
    : 0;

  const metricMaxValue = sortedByMetric.length
    ? Number(sortedByMetric[metricMaxIndex][metricKey])
    : 0;

  // інпут Value у Metrics: синхрон з повзунком, але без перезапису під час ручного вводу
  useEffect(() => {
    if (mode !== "metrics") return;
    if (metricEditingRef.current) return;
    setMetricValueText(fmt(selectedMetricValue, 4));
  }, [mode, metricKey, draftIndex, selectedMetricValue]);

  // Disabled Lower/Upper в Metrics режимі (беремо з вибраного об'єкта)
  const selectedMetricLower = selectedMetricObj
    ? Number(selectedMetricObj.lowerThreshold)
    : Number.isFinite(Number(lower))
    ? Number(lower)
    : 0.5;

  const selectedMetricUpper = selectedMetricObj
    ? Number(selectedMetricObj.upperThreshold)
    : Number.isFinite(Number(upper))
    ? Number(upper)
    : 0.5;

  // % позиція thumb в Metrics режимі (по індексу)
  const metricPct = metricMaxIndex > 0 ? (draftIndex / metricMaxIndex) * 100 : 0;

  // Metrics шкала: рівномірно METRICS_TICKS_COUNT точок від min до max
  const metricTicks = useMemo(() => {
    const count = Math.max(2, Number(METRICS_TICKS_COUNT) || 2);
    if (!sortedByMetric.length) return [];

    const maxIdx = metricMaxIndex;

    // рівномірно беремо ІНДЕКСИ по sortedByMetric,
    // і показуємо value метрики, яка реально стоїть на цих індексах
    return Array.from({ length: count }, (_, i) => {
      const idx = count === 1 ? 0 : Math.round((i * maxIdx) / (count - 1));
      const obj = sortedByMetric[idx];
      const val = obj ? Number(obj?.[metricKey]) : NaN;

      return {
        idx,
        val,
      };
    });
  }, [sortedByMetric, metricKey, metricMaxIndex]);


  useEffect(() => {
    if (mode !== "double") return;

    const nextLeft = clamp(roundToStep(Number(lower ?? 0.5), STEP), MIN, MAX);
    const nextRight = clamp(roundToStep(Number(upper ?? 0.5), STEP), MIN, MAX);

    setRawLeft(nextLeft);
    setRawRight(nextRight);
  }, [lower, upper, mode]);

  // ---------------- helpers commit ----------------
  const commitDouble = (nextLeft = rawLeft, nextRight = rawRight) => {
    const lo = Math.min(nextLeft, nextRight);
    const hi = Math.max(nextLeft, nextRight);

    const obj =
      (data || []).find(
        (o) =>
          Math.abs(Number(o?.lowerThreshold) - lo) < 1e-9 &&
          Math.abs(Number(o?.upperThreshold) - hi) < 1e-9
      ) || null;

    // зберігаємо стан окремо для Threshold
    // safeWrite(keyDouble, { rawLeft: nextLeft, rawRight: nextRight });
commitCb(lo, hi, obj);
    
    
  };

  const commitMetricsByIndex = (idx) => {
    const obj = sortedByMetric[idx] || null;
    if (!obj) return;

    const lo = Number(obj.lowerThreshold);
    const hi = Number(obj.upperThreshold);

    // в Metrics ми все одно керуємося вибраним об'єктом
    setRawLeft(lo);
    setRawRight(hi);

    // зберігаємо стан окремо для Metrics
    // safeWrite(keyMetrics, { metricKey, draftIndex: idx });
commitCb(lo, hi, obj);
    
    
  };

  const commitMetrics = () => commitMetricsByIndex(draftIndex);

  const findNearestMetricIndex = (value) => {
    if (!sortedByMetric.length) return 0;
    let bestIdx = 0;
    let bestDiff = Infinity;
    for (let i = 0; i < sortedByMetric.length; i++) {
      const v = Number(sortedByMetric[i]?.[metricKey]);
      if (!Number.isFinite(v)) continue;
      const d = Math.abs(v - value);
      if (d < bestDiff) {
        bestDiff = d;
        bestIdx = i;
      }
    }
    return clamp(bestIdx, 0, metricMaxIndex);
  };

  const applyMetricFromText = () => {
    metricEditingRef.current = false;

    if (!sortedByMetric.length) {
      setMetricValueText("");
      return;
    }

    const raw = toNumber(metricValueText, NaN);
    if (Number.isNaN(raw)) {
      setMetricValueText(fmt(selectedMetricValue, 4));
      return;
    }

    // clamp по фактичному min/max обраної метрики
    const clamped = clamp(raw, metricMinValue, metricMaxValue);
    const idx = findNearestMetricIndex(clamped);

    setDraftIndex(idx);
    // показуємо в полі реальне значення з дискретної шкали
    const realVal = Number(sortedByMetric[idx]?.[metricKey]);
    setMetricValueText(fmt(realVal, 4));

    // commit одразу з інпута
    setTimeout(() => commitMetricsByIndex(idx), 0);
  };

  // ---------------- DOUBLE: drag (тільки локально), commit на release ----------------
  const handleLeftSliderChange = (e) => {
    const val = clamp(roundToStep(toNumber(e.target.value, rawLeft), STEP), MIN, MAX);
    setRawLeft(val);
  };

  const handleRightSliderChange = (e) => {
    const val = clamp(roundToStep(toNumber(e.target.value, rawRight), STEP), MIN, MAX);
    setRawRight(val);
  };

  const handleDoubleRelease = () => {
    draggingRef.current = null;
    commitDouble(rawLeft, rawRight);
  };

  // ---------------- DOUBLE: inputs commit на blur/enter ----------------
  const [draftLowerText, setDraftLowerText] = useState("");
  const [draftUpperText, setDraftUpperText] = useState("");

  // ВІЗУАЛ: показуємо до 4 знаків, але без зайвих нулів
  useEffect(() => {
    setDraftLowerText(fmt(sorted.lo, 4));
    setDraftUpperText(fmt(sorted.hi, 4));
  }, [sorted.lo, sorted.hi]);

  const applyLowerFromText = () => {
    const raw = toNumber(draftLowerText, NaN);
    if (Number.isNaN(raw)) return;
    const v = clamp(roundToStep(raw, STEP), MIN, MAX);

    if (rawLeft <= rawRight) setRawLeft(v);
    else setRawRight(v);

    setTimeout(
      () => commitDouble(rawLeft <= rawRight ? v : rawLeft, rawLeft <= rawRight ? rawRight : v),
      0
    );
  };

  const applyUpperFromText = () => {
    const raw = toNumber(draftUpperText, NaN);
    if (Number.isNaN(raw)) return;
    const v = clamp(roundToStep(raw, STEP), MIN, MAX);

    if (rawLeft >= rawRight) setRawLeft(v);
    else setRawRight(v);

    setTimeout(
      () => commitDouble(rawLeft >= rawRight ? v : rawLeft, rawLeft >= rawRight ? rawRight : v),
      0
    );
  };

  // ---------------- METRICS: drag (локально), commit на release ----------------
  const handleMetricSliderChange = (e) => {
    const idx = clamp(toNumber(e.target.value, 0), 0, metricMaxIndex);
    setDraftIndex(idx);
  };

  const handleMetricRelease = () => {
    draggingRef.current = null;
    commitMetrics();
  };

  // ---------------- switch mode ----------------
  const handleSwitchToDouble = () => {
    setMode("double");

    // відновлюємо тільки Threshold-стан (якщо є)
    // const savedD = safeRead(keyDouble);
    // if (savedD && Number.isFinite(Number(savedD.rawLeft)) && Number.isFinite(Number(savedD.rawRight))) {
    //   setRawLeft(clamp(Number(savedD.rawLeft), MIN, MAX));
    //   setRawRight(clamp(Number(savedD.rawRight), MIN, MAX));
    // }
  };

  const handleSwitchToMetrics = () => {
    metricEditingRef.current = false;
    setMode("metrics");
    setDraftIndex(metricIndexFromThreshold);
  };

  useEffect(() => {
    if (mode !== "metrics") return;
    setDraftIndex(metricIndexFromThreshold);
  }, [mode, metricIndexFromThreshold]);

  // ---------------- range fill (для Threshold режиму) ----------------
  const leftPct = ((sorted.lo - MIN) / (MAX - MIN)) * 100;
  const rightPct = ((sorted.hi - MIN) / (MAX - MIN)) * 100;

  // z-index: активна ручка зверху
  const leftZ = draggingRef.current === "left" ? 4 : 2;
  const rightZ = draggingRef.current === "right" ? 4 : 3;

  return (
    <div className="tresh_block">
      <div className="tresh_block_fline">
        <div className="fline">
          <div
            className={mode === "double" ? "fline_but_left active" : "fline_but_left"}
            onClick={handleSwitchToDouble}
          >
            Threshold
          </div>
          <div
            className={mode === "metrics" ? "fline_but_right active" : "fline_but_right"}
            onClick={handleSwitchToMetrics}
          >
            Metrics
          </div>
        </div>

        <div className="fline_t">
          {mode === "double" ? (
            <>
              <div className="fline_block">
                <div>Lower</div>
                <input
                  type="number"
                  step={STEP}
                  min={MIN}
                  max={MAX}
                  value={draftLowerText}
                  onChange={(e) => setDraftLowerText(e.target.value)}
                  onBlur={applyLowerFromText}
                  onKeyDown={(e) => {
                    if (e.key === "Enter") e.currentTarget.blur();
                  }}
                />
              </div>

              <div className="fline_block">
                <div>Upper</div>
                <input
                  type="number"
                  step={STEP}
                  min={MIN}
                  max={MAX}
                  value={draftUpperText}
                  onChange={(e) => setDraftUpperText(e.target.value)}
                  onBlur={applyUpperFromText}
                  onKeyDown={(e) => {
                    if (e.key === "Enter") e.currentTarget.blur();
                  }}
                />
              </div>
            </>
          ) : (
            <>
              <div className="fline_block">
                <div className="text_tresh">Threshold: </div>
                <div className="fline_block text_lu">
                  <div>Lower</div>
                  <input type="text" className="input_lu" value={fmt(selectedMetricLower, 4)} disabled readOnly />
                </div>

                <div className="fline_block text_lu">
                  <div>Upper</div>
                  <input type="text" className="input_lu" value={fmt(selectedMetricUpper, 4)} disabled readOnly />
                </div>

                <div className="text_metrix">Metrics: </div>
                <select
                  value={metricKey}
                  className="select_metrix"
                  onChange={(e) => {
                    metricEditingRef.current = false;
                    const nextKey = e.target.value;
                    setMetricKey(nextKey);
                    setDraftIndex(0);
                    // persist metric selection even before slider move
                    // safeWrite(keyMetrics, { metricKey: nextKey, draftIndex: 0 });
                  }}
                  style={{ height: 38 }}
                >
                  {METRIC_OPTIONS.map((o) => (
                    <option key={o.value} value={o.value}>
                      {o.label}
                    </option>
                  ))}
                </select>
              </div>

              <div className="fline_block">
                <input
                  type="text"
                  className="input_lu"
                  value={metricValueText}
                  disabled={sortedByMetric.length === 0}
                  onFocus={() => {
                    metricEditingRef.current = true;
                  }}
                  onChange={(e) => setMetricValueText(e.target.value)}
                  onBlur={applyMetricFromText}
                  onKeyDown={(e) => {
                    if (e.key === "Enter") e.currentTarget.blur();
                  }}
                />
              </div>

              {/* Lower/Upper у Metrics режимі: disabled + формат */}
              
            </>
          )}
        </div>
      </div>

      <div className="slider" style={{ position: "relative" }}>
        <div className="slider__track" />

        {mode === "double" ? (
          <>
            <div
              className="slider__range"
              style={{ left: `${leftPct}%`, width: `${rightPct - leftPct}%` }}
            />

            <input
              type="range"
              min={MIN}
              max={MAX}
              step={STEP}
              value={rawLeft}
              onMouseDown={() => (draggingRef.current = "left")}
              onTouchStart={() => (draggingRef.current = "left")}
              onMouseUp={handleDoubleRelease}
              onTouchEnd={handleDoubleRelease}
              onChange={handleLeftSliderChange}
              className="thumb thumb--left"
              style={{ zIndex: leftZ }}
            />

            <input
              type="range"
              min={MIN}
              max={MAX}
              step={STEP}
              value={rawRight}
              onMouseDown={() => (draggingRef.current = "right")}
              onTouchStart={() => (draggingRef.current = "right")}
              onMouseUp={handleDoubleRelease}
              onTouchEnd={handleDoubleRelease}
              onChange={handleRightSliderChange}
              className="thumb thumb--right"
              style={{ zIndex: rightZ }}
            />
          </>
        ) : (
          <>
            {/* Metrics: шкала з рівномірними точками, формат без зайвих нулів */}
            <div
           
              style={{
                display: "flex",
                justifyContent: "space-between",
                fontSize: 12,
                color: "rgba(2,2,3,0.6)",
                position: 'relative',
                top: '21px'
              }}
            >
              {metricTicks.length ? (
                metricTicks.map((t, i) => (
                  <span
                    key={i}
                     className="sl_metrx"
                    title={`Index ${t.idx + 1} / ${metricMaxIndex + 1}`}
                  >
                    <span className="chert"></span>
                    {fmt(t.val, 4)}
                  </span>
                ))
              ) : (
                Array.from({ length: Math.max(2, METRICS_TICKS_COUNT) }).map((_, i) => (
                  <span key={i} />
                ))
              )}

            </div>

            {/* Плаваючий value-box, який їздить з повзунком */}
            <div
              style={{
                position: "absolute",
                left: `calc(${metricPct}% )`,
                top: 32,
                transform: "translateX(-50%)",
                background: "#F5C538",
                padding: "2px 8px",
                borderRadius: 8,
                fontSize: 12,
                lineHeight: "16px",
                whiteSpace: "nowrap",
                zIndex: 5,
              }}
            >
              {fmt(selectedMetricValue, 4)}
            </div>

            <input
              type="range"
              min={0}
              max={metricMaxIndex}
              step={1}
              value={draftIndex}
              onMouseDown={() => (draggingRef.current = "metric")}
              onTouchStart={() => (draggingRef.current = "metric")}
              onMouseUp={handleMetricRelease}
              onTouchEnd={handleMetricRelease}
              onChange={handleMetricSliderChange}
              className="thumb thumb--right"
              style={{ zIndex: 4 }}
              disabled={sortedByMetric.length === 0}
            />
          </>
        )}
      </div>

      {/* шкала: тільки для Threshold (залишаємо як було, але формат без зайвих нулів) */}
      {mode === "double" ? (
        <div className="ticks">
          {Array.from({ length: 21 }).map((_, i) => {
            const val = i * 0.05;
            // Active ONLY under the current thumbs (so the previous one turns off automatically)
            const leftMark = roundToStep(rawLeft, STEP);
            const rightMark = roundToStep(rawRight, STEP);
            const isActive =
              Math.abs(val - leftMark) < 1e-9 || Math.abs(val - rightMark) < 1e-9;
            return (
              <div key={i} className="tick">
                <div className="tick-line" />
                <div className={`tick-label${isActive ? " active" : ""}`}>{fmt(val, 4)}</div>
              </div>
            );
          })}
        </div>
      ) : null}
    </div>
  );
}
